// Existing resources
import CompanyResource from '../resources/company'
import DeveloperProfileResource from '../resources/developerprofile'
import EducationResource from '../resources/education'
import ExperienceResource from '../resources/experience'
import ImageResource from '../resources/image'
import KeywordResource from '../resources/keyword'
import ListingResource from '../resources/listing'
import LookingForResource from '../resources/lookingfor'
import MarketResource from '../resources/market'
import MessageResource from '../resources/message'
import MetroAreaResource from '../resources/metroarea'
import RoleResource from '../resources/role'
import SchoolResource from '../resources/school'
import SkillResource from '../resources/skill'
import UserResource from '../resources/user'

export default {
    install(Vue) {
        Vue.prototype.$resources = {
            CompanyResource,
            DeveloperProfileResource,
            EducationResource,
            ExperienceResource,
            ImageResource,
            KeywordResource,
            ListingResource,
            LookingForResource,
            MarketResource,
            MessageResource,
            MetroAreaResource,
            RoleResource,
            SchoolResource,
            SkillResource,
            UserResource,
        }
    }
}
